import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, keyframes, animate, transition, style } from '@angular/animations';
import { ApiHttpClient } from 'app/http/clients/api';
import { Observable, of } from 'rxjs';
import { PusherService } from 'app/modules/shared/services/pusher.service';
import { take } from 'rxjs/operators';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';
import { LenderUser } from 'app/models/dto/lender-user.model';
import { Select } from '@ngxs/store';
import { Router } from '@angular/router';

@Component({
    selector: 'cadence',
    templateUrl: 'cadence.component.html',
    styleUrls: ['cadence.component.scss'],
    animations: [
        trigger('rubberBand', [
            transition('inactive => active', animate(1000, keyframes([
                style({transform: 'none'}),
                style({transform: 'scale3d(1.25, 0.75, 1)'}),
                style({transform: 'scale3d(0.75, 1.25, 1)'}),
                style({transform: 'scale3d(1.15, 0.85, 1)'}),
                style({transform: 'scale3d(0.95, 1.05, 1)'}),
                style({transform: 'scale3d(1.05, 0.95, 1)'}),
                style({transform: 'none'})
            ]))),
        ])
    ]
})

export class CadenceComponent implements OnInit, OnDestroy {

  @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;

    borrower: string;
    borrowerId: number;
    lenderUserId: number;
    attempt: number;
    cadenceTitle: string;
    call: boolean;
    message: boolean;
    sms: boolean;
    rubberBandState: string;
    visible$ = new Observable;
    private cadence;

    constructor (
        private http: ApiHttpClient,
        private pusherService: PusherService,
        private router: Router
    ) { }

    ngOnInit() {
        this.lenderUser$.pipe(take(1)).subscribe((user) => {
            this.visible$ = of(user.permissions.includes('viewCadence'));
            this.lenderUserId = user.id;
            this.pusherSubscribe(this.lenderUserId);
        });
        this.getCadence();
    }

    triggerAnimation() {
        this.rubberBandState = 'active';
    }

    resetAnimation() {
        this.rubberBandState = 'inactive';
    }

    viewBorrower(borrowerId) {
      this.router.navigate(['/borrower/', borrowerId]);
    }

    getCadence() {
       this.http.get('/cadence').subscribe({
           next: data => { this.cadence = data; },
           error: err => console.error(err),
           complete: () => {
            this.borrowerId = this.cadence[0] ? this.cadence[0].borrowerId : null;
            this.borrower = this.cadence[0] ? this.cadence[0].borrowerName : null;
            this.attempt = this.cadence[0] ? this.cadence[0].attemptNumber : null;
            this.cadenceTitle = this.cadence[0] ? this.cadence[0].cadenceTitle : null;
          }
      });
    }

    pusherSubscribe(userId: number) {
        const channel = this.pusherService.subscribe(`lenderUser-${userId}-borrowerCadence`);
        channel.bind_global(eventName => {
            switch (eventName) {
                case 'update':
                    this.getCadence();
                    this.triggerAnimation();
                    break;
            }
        });
    }

    pusherUnsubscribe(userId: number) {
        this.pusherService.unsubscribe(`lenderUser-${userId}-borrowerCadence`);
    }

    ngOnDestroy() {
        this.pusherUnsubscribe(this.lenderUserId);
    }

}
